module.exports = __webpack_public_path__ + "static/image1-d557cc6001c60ecfc64f7632a949a247.png";